/* @flow */
import { Container } from 'flux/utils';
import React from 'react';

import DeliveryModal from 'chat/components/DeliveryModal.jsx';
import DeliveryStore from 'stores/DeliveryStore';
import DeliverySummaryStore from 'stores/DeliverySummaryStore';
import Message from 'entities/Message';
import ChatMessage from 'entities/ChatMessage';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';
import MessageActions from 'groups/actions/MessageActions';

const DELIVERY_SUMMARY_UNAVAILABLE_THRESHOLD = 24 * 60 * 60 * 1000; // 1 day

class DeliveryModalContainer extends React.Component {
  props: {
    message: Message | ChatMessage,
  };

  state: {
    summary: ?MessageDeliverySummary,
    loaded: boolean,
    tooSoon: boolean,
  };

  static getStores() {
    return [
      DeliveryStore,
      DeliverySummaryStore,
    ];
  }

  static calculateState(prevState, props) {
    let summary: ?MessageDeliverySummary;
    let loaded: ?boolean;
    let tooSoon: boolean = false;

    if (props.message instanceof Message) {
      summary = DeliverySummaryStore.getByMessageId(props.message.getUuid());
      loaded = DeliverySummaryStore.isDeliverySummaryLoaded(props.message.id);
      if (loaded && !summary) {
        tooSoon = Date.now() - props.message.getSentAt() < DELIVERY_SUMMARY_UNAVAILABLE_THRESHOLD;
      }
    } else if (props.message instanceof ChatMessage) {
      summary = DeliveryStore.getDeliveryByMessageId(props.message.id).getReadSummary();
      loaded = true; /* we can't load chat msg summary, they already are in the message object! */
    }

    return {
      summary,
      loaded,
      tooSoon,
    };
  }

  componentWillMount() {
    const { message } = this.props;

    if (message instanceof Message) {
      MessageActions.loadDeliverySummary(message);
    }
  }

  render() {
    return <DeliveryModal {...this.props} {...this.state} />;
  }
}

export default Container.create(DeliveryModalContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/chat/containers/DeliveryModalContainer.jsx